import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><rect x={114.76} y={88.277} style={{
    fill: "#FFE15A"
  }} width={282.48} height={335.45} /><path style={{
    fill: "#73AF00"
  }} d="M473.655,423.721c21.177,0,38.345-17.167,38.345-38.345V126.618  c0-21.177-17.167-38.345-38.345-38.345h-76.414v335.448H473.655z" /><path style={{
    fill: "#4173CD"
  }} d="M38.345,423.721h76.414V88.273H38.345C17.167,88.273,0,105.44,0,126.618v258.759  C0,406.554,17.167,423.721,38.345,423.721z" /><g><polygon style={{
      fill: "#73AF00"
    }} points="191.886,251.475 220.522,308.746 249.158,251.475 220.522,194.204  " /><polygon style={{
      fill: "#73AF00"
    }} points="262.844,251.475 291.479,308.746 320.115,251.475 291.479,194.204  " /><polygon style={{
      fill: "#73AF00"
    }} points="227.364,320.326 256,377.597 284.636,320.326 256,263.056  " /></g><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };